import { ProductBundle } from './Product'

export const enum PrescriptionFileStatus {
  /* initial status when file is uploaded */
  UPLOADED = 'UPLOADED',
  /* after upload, BE will trigger OCR / extraction */
  SENT_FOR_OCR = 'SENT_FOR_OCR',
  /* response from OCR / extraction */
  EXTRACTED = 'EXTRACTED',
  /* after calling validate API, we get either FOR_REVIEW or VALID */
  FOR_REVIEW = 'FOR_REVIEW',
  VALID = 'VALID',
  AUTO_APPROVED = 'AUTO_APPROVED',
  AUTO_DISAPPROVED = 'AUTO_DISAPPROVED',
  APPROVED = 'APPROVED',
  DISAPPROVED = 'DISAPPROVED',
}

export type PrescriptionFile = {
  id: string
  url: string
  fileName: string
  status: PrescriptionFileStatus
  productIds?: string[]
  products?: ProductBundle[]
  validationErrors?: PrescriptionFileError[]
}

export const enum PrescriptionFileError {
  LOW_OVERALL_ACCURACY = 'LOW_OVERALL_ACCURACY',
  PRODUCT_MISMATCH_GLASSES_RX = 'PRODUCT_MISMATCH_GLASSES_RX',
  PRODUCT_MISMATCH_CONTACTS_RX = 'PRODUCT_MISMATCH_CONTACTS_RX',
  PATIENT_NAME_MISMATCH = 'PATIENT_NAME_MISMATCH',
  PRESCRIBER_NAME_MISMATCH = 'PRESCRIBER_NAME_MISMATCH',
}

export type PrescriptionFileArgs = {
  claimRecordId: string
  prescriptionId?: string
}

export type PrescriptionFileSelection = {
  index: number
  name?: string
}

export const enum UploadMode {
  SINGLE = 'single',
  DEFAULT = 'default',
}

export type ImagePreviewParam = {
  url: string
  name: string
}

export const enum PrescriptionHelpModal {
  HELP_GLASSES_RX = 'HELP_GLASSES_RX',
  HELP_CONTACTS_RX = 'HELP_CONTACTS_RX',
  HELP_TAKE_CLEAR_PHOTO = 'HELP_TAKE_CLEAR_PHOTO',
}
